import { render, staticRenderFns } from "./modal-add-whelp-birth-type.vue?vue&type=template&id=7f94c7cc&scoped=true&lang=pug"
import script from "./modal-add-whelp-birth-type.js?vue&type=script&lang=js&external"
export * from "./modal-add-whelp-birth-type.js?vue&type=script&lang=js&external"
import style0 from "./modal-add-whelp-birth-type.vue?vue&type=style&index=0&id=7f94c7cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f94c7cc",
  null
  
)

export default component.exports